import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { HttpClient } from '@angular/common/http';
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';
import { ChangeDetectorRef } from '@angular/core';
// import { DeleteAttachmentComponent } from '../delete-attachment/delete-attachment.component';
import { DeleteAttachmentJobComponent } from '../delete-attachment-job/delete-attachment-job.component';
import * as saveAs from 'file-saver';

@Component({
  selector: 'app-campaign-job-attachments',
  templateUrl: './campaign-job-attachments.component.html',
  styleUrls: ['./campaign-job-attachments.component.scss']
})
export class CampaignJobAttachmentsComponent implements OnInit {

  authToken = localStorage.getItem('token')
  adminUser:any;
  selectedUser:any;
 
  currentDate: Date = new Date();
  fileType:any;

  allData:any;
  jobFiles:any = [];
  // jobFilesAttachments:any;
  jobFilesAttachments: File[] = [];
  jobFilesAttachmentsPreviewUrls: (string | ArrayBuffer)[] = [];
  // showOverlay = false;
  previewImageUrl: string | null = null;
  subText:any;
  jobTitle:any;
  btnStatus = false;
  selectedItems: boolean[] = [];
  deleteAttachmentComponent:MatDialogRef<DeleteAttachmentJobComponent>;
  showComponentLoader = true;
  userInfo = JSON.parse(localStorage.getItem('userInfo'));
  isAllSelected = false;
  
  constructor(
    private dialogRef: MatDialogRef<CampaignJobAttachmentsComponent>,
    private _serverService:ServerService,
    private http:HttpClient,
    private dialog:MatDialog,
    private clipBoardMessageService:messageService,
    private changeDetectorRef:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) { 
    this.selectedItems = []
    this.isAllSelected = false;
    this.allData = this.data;
    

    // console.log(this.allData.file_type_job)
    // console.log(this.data)

    if(this.allData.job_table_type == 'creative_file' && this.allData.file_type_job == 'creative'){
      this.jobFiles = this.allData.asset;
      this.jobTitle = 'Creative Job';
      this.subText = "Creative File"
     
      if(this.jobFiles){
        this.selectedItems = new Array(this.jobFiles.length).fill(false);
      }
      
    }
    else if(this.allData.job_table_type == 'open_file' && this.allData.file_type_job == 'creative'){
      this.jobFiles = this.allData.open_files;
      this.jobTitle = 'Creative Job'
      this.subText = "Open File"
      if(this.jobFiles){
      this.selectedItems = new Array(this.jobFiles.length).fill(false);
      }
    }
    else if(this.allData.file_type_job == 'presales'){
      // console.log(this.allData.file_type_job);
      this.jobFiles = this.allData.pitch;
      this.subText = "Pitch File"
      // console.log(this.allData.pitch)
      if(this.jobFiles){
        this.selectedItems = new Array(this.jobFiles.length).fill(false);
        }
      this.jobTitle = 'Pre Sales Job'
    }
    else if(this.allData.file_type_job == 'marketing'){
      this.jobTitle = 'Marketing Job';
      this.subText = "Files"
     
      this.jobFiles = this.allData.files;
      if(this.jobFiles){
        this.selectedItems = new Array(this.jobFiles.length).fill(false);
        }
    }
    else{
      this.jobFiles = this.allData.supporting_files;
      this.jobTitle = 'Escalations'
      this.subText = "Supporting File"
      if(this.jobFiles){
        this.selectedItems = new Array(this.jobFiles.length).fill(false);
        }
    }
    // console.log(this.jobFiles)
    // console.log(this.jobFiles)
    // jobFiles?.length !== 0 || jobFiles
    // this.jobFiles = data.asset;
    this.showComponentLoader = false;
    // console.log(this.jobFiles)
  }

  ngOnInit() {
    localStorage.setItem('Attachment_job','false')
  }
 
  onFileSelected(event: Event): void {
    this.fileType = '';
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      const MAX_FILE_SIZE = 100 * 1024 * 1024; 
      files.forEach(file => {
        if (file.size > MAX_FILE_SIZE) {
          // Show error message and skip this file
          this.clipBoardMessageService.showMessgeInText(
            `File "${file.name}" exceeds the maximum allowed size of 100MB.`,
            'error-snackbar'
          );
          input.value = '';
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.jobFilesAttachments.push(file);
          this.jobFilesAttachmentsPreviewUrls.push(reader.result);
          this.changeDetectorRef.detectChanges();
        };
        reader.readAsDataURL(file);
      });
      input.value = '';
      // console.log(this.brochureFiles)
    }
  }

  discardFile(index: number, container: string): void {
    this.jobFilesAttachments.splice(index, 1);
          this.jobFilesAttachmentsPreviewUrls.splice(index, 1);

  }
 

  close() {
    this.dialogRef.close();

}

apply() {
  this.btnStatus = true;
  this.showComponentLoader = true;
  const formData: FormData = new FormData();
formData.append('campaign_id',this.data.campaign_id)
const appendFiles = (files: File[], fieldName: string) => { files.forEach(file => formData.append(fieldName, file)); };
if(this.allData.job_table_type == 'creative_file' && this.allData.status_changed != 'status_changed'){
  appendFiles(this.jobFilesAttachments, "asset[]");
}
else if(this.allData.job_table_type == 'open_file'){
  appendFiles(this.jobFilesAttachments, "open_files[]");
}
else if( this.allData.file_type_job == 'presales'){
  appendFiles(this.jobFilesAttachments, "pitch");
}
else if( this.allData.file_type_job == 'marketing'){
  appendFiles(this.jobFilesAttachments, "files[]");
}
else if(this.allData.job_table_type == 'creative_file' && this.allData.status_changed == 'status_changed'){
  appendFiles(this.jobFilesAttachments, "asset[]");
  let dateTime = new Date()
  // if(this.allData.new_status == 'Done'){
    formData.append("completed_at", this.getCurrentDateTime());
  // }
 
  formData.append("status", "Done");
  formData.append('campaign_id',this.data.campaign_id)
}
else{
  appendFiles(this.jobFilesAttachments, "supporting_files[]");
}

  // appendFiles(this.mediaFiles, "media_plan_attachment[]");
  //  appendFiles(this.creativeFiles, "creative_attachment[]");

// console.log(this.allData.file_type_job )
  let url;
  if(this.allData.file_type_job == 'creative'){
    url  = 'campaign_module/creative_jobs/'+this.data.id
  }
  else if(this.allData.file_type_job == 'presales'){
    url  = 'campaign_module/pre_sales_jobs/'+this.data.id
  }
  else if(this.allData.file_type_job == 'marketing'){
    url  = 'campaign_module/marketing_jobs/'+this.data.id
  }
  else{
    url  = 'campaign_module/escalation/'+this.data.id
  }
  // url  = 'campaign_module/creative_jobs/'+this.data.id
  // Send formData to server
  this._serverService.updateCreativeJobDetails(url,formData, this.authToken).subscribe(response => {
    this.clipBoardMessageService.showMessgeInText("File Attached Succesfully", "success-snackbar")
    this.showComponentLoader = false;
    this.dialogRef.close(response);
    
  }, error => {
    this.btnStatus = false;
    console.error('Upload failed', error);
  });
}
openFullPreview(links:any){

  this.previewImageUrl = links;
  window.open(this.previewImageUrl, '_blank');

}
download(url:any,filename:any){
  this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
    const link = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);  // Clean up
  });
  
}
closeOverlay(){
  // this.showOverlay = false;
  this.previewImageUrl = null
}
getCurrentDateTime(): string {
  const date = new Date();
  
  const pad = (n: number) => n < 10 ? '0' + n : n;
  
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const day = pad(date.getDate());
  
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const milliseconds = pad(date.getMilliseconds());
  
  const timezoneOffset = -date.getTimezoneOffset();
  const timezoneHours = pad(Math.floor(Math.abs(timezoneOffset) / 60));
  const timezoneMinutes = pad(Math.abs(timezoneOffset) % 60);
  const timezoneSign = timezoneOffset >= 0 ? '+' : '-';
  
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneSign}${timezoneHours}:${timezoneMinutes}`;
}

openFullPreviewJobs(links:any){

  // openFullPreview(links: any) {
    const fileUrl = links;
    // console.log(fileUrl)
    const fileExtension = fileUrl.name.split('.').pop().toLowerCase();
    // console.log(fileExtension)
  
    switch (fileExtension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        // Open image in a new tab
        this.previewImageUrl = fileUrl.link;
        // console.log(fileUrl.link)
        window.open(this.previewImageUrl, '_blank');
        break;
  
      case 'mp4':
      case 'webm':
      case 'ogg':
        // Open video in a new tab
        this.previewImageUrl = fileUrl.link;
        const videoHtml = `<video width="100%" height="100%" controls autoplay>
                             <source src="${this.previewImageUrl}" type="video/${fileExtension}">
                             Your browser does not support the video tag.
                           </video>`;
        const videoWindow = window.open("", "_blank");
        if (videoWindow) {
          videoWindow.document.write(videoHtml);
        }
        break;
  
      case 'pdf':
        // Open PDF in a new tab
        this.previewImageUrl = fileUrl.link;
        window.open(this.previewImageUrl, '_blank');
        break;
  
     
      case 'xls':
      case 'xlsx':
      case 'doc':
      case 'docx':
        case 'ppt':
    case 'pptx':
      
        // Open these files in Google Docs or a new tab depending on the format
        this.previewImageUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl.link)}&embedded=true`;
        window.open(this.previewImageUrl, '_blank');
        break;
        case 'csv':
      // Directly open the CSV file
      window.open(fileUrl.link, '_blank');
      break;
      default:
        // Handle other file types or show a message
        alert('File type not supported for preview.');
        break;
    }
  // }
  

}
deleteModal(temp){
  // console.log(item)
  // console.log(this.selectedItems)
  let item= []
  // item['campaign_id'] = this.allData.id;
  // item['type_of_attachment'] = type;

  item['selected_files']=temp;
  item['job_id'] = this.allData.id;
  item['campaign_id']= this.allData.campaign_id
  item['table_name']=this.allData.file_type_job;
  item['job_attachment_type']=this.allData.job_table_type
  
  this.deleteAttachmentComponent = this.dialog.open(DeleteAttachmentJobComponent, {
    hasBackdrop: true,
    disableClose: false,
    autoFocus: true,
    width: '520px',
    panelClass: 'blue-snackbar',
    data: item
  });
  this.deleteAttachmentComponent.afterClosed().subscribe(result => {
    // console.log(result)
    this.showComponentLoader = true
    if(result != undefined){
      // console.log(result)
      if(result.object_type == "pre_sales_jobs"){
        this.jobFiles = []
      }
      else{
      this.jobFiles =  this.jobFiles.filter((brochure) => !result.asset_ids.includes(brochure.id));
      // console.log(this.jobFiles)
      }
      localStorage.setItem('Attachment_job','true')
      // this.selectedItems = []
      this.showComponentLoader = false;
    }
    this.selectedItems = new Array(this.jobFiles.length).fill(false);
    this.showComponentLoader = false;
    this.isAllSelected = false
    // console.log(this.brochures)
  });
  


}
selectAll() {

  // console.log(event.checked)
  // console.log(this.isAllSelected)
  // this.isAllSelected = event.checked;
  if(this.isAllSelected){
    this.selectedItems.fill(this.isAllSelected);
  }
  else{
    this.selectedItems = new Array(this.jobFiles.length).fill(false);
  }
  

}

checkSelection() {
  // console.log(this.selectedItems)
  this.isAllSelected = this.selectedItems.every((checked) => checked);
  // console.log(this.selectedItems)
  // console.log(this.isAllSelected)
}
del(){
  let temp = this.getSelectedIds()
  this.deleteModal(temp)

}
getSelectedIds(): string[] {
  if(this.selectedItems.length != 0){
  return this.jobFiles
    .filter((_, index) => this.selectedItems[index]) // Filter only selected items
    .map(file => file.id); // Extract their IDs
}
}
downloadBulk(){
  // console.log(this.data)
  let temp = this.getSelectedIds()
  // console.log(temp)
  this.showComponentLoader = true;

  let body = {
    "campaign_id": this.data.campaign_id,
    // "object_type": "creative_jobs",
    "object_id": this.data.id,
    // "asset_type": this.data.job_attachment_type,
    // "asset_type": "open_files",
    
  }
  // if(this.allData.job_table_type == 'creative_file' && this.allData.file_type_job == 'creative')
  if(this.data.job_table_type == "open_file" && this.data.file_type_job == "creative"){
    body["object_type"] = "creative_jobs";
    body["asset_type"] = "open_files";
    body["asset_ids"] = temp;
  }
  else if(this.data.job_table_type == "creative_file" && this.data.file_type_job == "creative"){
    body["object_type"] = "creative_jobs";
    body["asset_type"] = "asset";
    body["asset_ids"] = temp;

  }
  else if(this.data.file_type_job == "marketing"){
    body["object_type"] = "marketing_jobs";
    body["asset_type"] = "files";
    body["asset_ids"] = temp;
  }
  else if(this.data.file_type_job == "presales"){
    body["object_type"] = "pre_sales_jobs";
    body["asset_type"] = "pitch";
  }
  else if(this.data.file_type_job == "escalation"){
    body["object_type"] = "escalations";
    body["asset_type"] = "supporting_files";
    body["asset_ids"] = temp;
  }


      let url = "campaign_module/campaign/download_asset"
      // if(this.selectedItems.length == 1){
      this._serverService.downloadZipFile(url, body)
      .subscribe((data) => {
        const contentDisposition = data.headers.get('content-disposition');
        const contentType = data.headers.get('content-type')
        const regex = /filename="([^"]+)"/;
        const match = contentDisposition.match(regex);
        saveAs(new Blob([data.body], { type: contentType }), match[1])
        this.showComponentLoader = false
          })
        
  
  }
    }



